<template>
  <publishList></publishList>
  <!-- <div style="width:100% ;height: 100%;box-sizing: border-box;">
    <el-tabs class="product_management_box" v-model="activeName" >
      <el-tab-pane name="first">
        <span slot="label" style="padding: 0 15px;">项目统计</span>
        <publishList v-if="activeName === 'first'"></publishList>
      </el-tab-pane>
    </el-tabs>
  </div> -->
</template>
<script>
import publishList from "./publishList.vue"

export default {
  name: "",
  components:{
    publishList,
  },
  created() {},
  data() {
    return {
      // activeName: 'first',
    };
  },
}
</script>



// WEBPACK FOOTER //
// src/studio/projectStatistics/main.vue